import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import CustomBaseProvider from './CustomBaseProvider';
import { initFocusVisible, teardown } from '../baseui/utils/focusVisible';
import { DocumentProvider, useDocument } from './DocumentProvider';
import { StyleProvider, getStyleEngine } from '../styleEngine';
import { LocaleProvider } from '../locale';
// import { LAYERS_DEFAULT_ZINDEX } from '../layer';
import { ThemeProvider, useTheme } from '../theme';
import AiIconLinearGradients from './AiIconLinearGradients';
import { useHasMounted } from '../hooks/useHasMounted';
var LAYERS_DEFAULT_ZINDEX = 9999;
function SpacewebProvider(props) {
    var children = props.children, _a = props.layersZIndex, layersZIndex = _a === void 0 ? LAYERS_DEFAULT_ZINDEX : _a, overrides = props.overrides, theme = props.theme, locale = props.locale, _b = props.debug, debug = _b === void 0 ? false : _b, density = props.density, langCode = props.langCode;
    var doc = useDocument();
    var styleEngine = props.styleEngine || getStyleEngine(doc);
    // TODO: This must be removed once baseui code exposes focusVisible from utils/index
    // https://github.com/uber/baseweb/issues/3322
    useEffect(function () {
        initFocusVisible({ ownerDocument: doc });
        return function () { return teardown(doc); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var outerTheme = useTheme();
    var direction = props.direction || outerTheme.direction || 'ltr';
    var localeValue = useMemo(function () { return (__assign(__assign({}, locale), { langCode: langCode })); }, [locale, langCode]);
    var themeValue = useMemo(function () { return (__assign(__assign({}, theme), { direction: direction })); }, [theme, direction]);
    var hasMounted = useHasMounted();
    return (_jsx(StyleProvider, __assign({ debug: debug, styleEngine: styleEngine }, { children: _jsx(ThemeProvider, __assign({ theme: themeValue, containerElement: hasMounted ? doc.documentElement : undefined, density: density }, { children: _jsx(LocaleProvider, __assign({ locale: localeValue }, { children: _jsxs(CustomBaseProvider, __assign({ zIndex: layersZIndex, host: doc === null || doc === void 0 ? void 0 : doc.body }, { children: [children, _jsx(AiIconLinearGradients, {}, void 0)] }), void 0) }), void 0) }), void 0) }), void 0));
}
function SpacewebProviderWithDoc(_a) {
    var ownerDocument = _a.ownerDocument, children = _a.children, rest = __rest(_a, ["ownerDocument", "children"]);
    return (_jsx(DocumentProvider, __assign({ value: ownerDocument }, { children: _jsx(SpacewebProvider, __assign({}, rest, { children: children }), void 0) }), void 0));
}
export default SpacewebProviderWithDoc;
